export enum ProductCategory {
  GAS = 'Gas',
  STROM = 'Strom',
}
